import { render, staticRenderFns } from "./AdminCall.vue?vue&type=template&id=ce7f0376&scoped=true&"
import script from "./AdminCall.vue?vue&type=script&lang=js&"
export * from "./AdminCall.vue?vue&type=script&lang=js&"
import style0 from "./AdminCall.vue?vue&type=style&index=0&id=ce7f0376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7f0376",
  null
  
)

export default component.exports